"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.headerClassFactory = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var tableDescriptorTypes_1 = require("./tableDescriptorTypes");
function headerClassFactory(table, _props, classList) {
    return function (headerClassParams) {
        var tableDescriptor = table.tableDescriptor;
        var colDef = headerClassParams.colDef;
        var colId = tableDescriptorTypes_1.agColId(colDef);
        if (!colId) {
            return classnames_1.default(classList);
        }
        if (colId === tableDescriptorTypes_1.ColumnGroupingDescriptorId) {
            // This is the special, presentation-only ColGroupDef which communicates to the user
            // what attributes are used for grouping the column header.
            return classnames_1.default(classList, "gd-column-group-header", "s-table-column-group-header-descriptor", !tableDescriptor.sliceColCount() ? "gd-column-group-header--first" : null);
        }
        else {
            var colDesc = tableDescriptor.getCol(colId);
            var treeIndexes = colDesc.fullIndexPathToHere;
            var indexWithinGroup = treeIndexes ? treeIndexes[treeIndexes.length - 1] : undefined;
            var noLeftBorder = tableDescriptor.isFirstCol(colId) || !tableDescriptor.hasScopingCols();
            var absoluteColIndex = tableDescriptorTypes_1.isSeriesCol(colDesc)
                ? tableDescriptor.getAbsoluteLeafColIndex(colDesc)
                : undefined;
            return classnames_1.default(classList, "gd-column-group-header", 
            // Funny stuff begin
            // NOTE: this funny stuff is here to mimic how selectors were originally created.it does not seem
            //  to make much sense :)
            indexWithinGroup !== undefined ? "gd-column-group-header-" + indexWithinGroup : null, indexWithinGroup !== undefined
                ? "s-table-measure-column-header-group-cell-" + indexWithinGroup
                : null, 
            // Funny stuff end
            indexWithinGroup !== undefined && !tableDescriptorTypes_1.isSliceCol(colDesc)
                ? "s-table-measure-column-header-cell-" + indexWithinGroup
                : null, absoluteColIndex !== undefined
                ? "s-table-measure-column-header-index-" + absoluteColIndex
                : null, noLeftBorder ? "gd-column-group-header--first" : null, !colDef.headerName ? "gd-column-group-header--empty" : null);
        }
    };
}
exports.headerClassFactory = headerClassFactory;
//# sourceMappingURL=colDefHeaderClass.js.map